export default {
  title: 'Nahláste nám, když něco nefunguje',
  questions: [
    { id: 'miesto', type: 'text', label: 'Miesto' },
    { id: 'popis', type: 'multiline', label: 'Popis problému' },
  ],
}



// WEBPACK FOOTER //
// ./src/content/installfest/addons/feedback/reportProblem.js